import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import flatten from 'lodash/flatten';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import some from 'lodash/some';
import { Link } from 'react-router-dom';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Button from 'yoda-core-components/lib/components/Button/Button';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Plus from 'yoda-core-components/lib/assets/svg/Plus.svg';
import Login from 'yoda-core-components/lib/assets/svg/Login.svg';
import AccountApollo from 'yoda-core-components/lib/assets/svg/AccountApollo.svg';
import TrackOrder from 'yoda-core-components/lib/assets/svg/TrackOrder.svg';
import Address from 'yoda-core-components/lib/assets/svg/AddressNew.svg';
import Wallet from 'yoda-core-components/lib/assets/svg/Wallet.svg';
import HeartFill from 'yoda-core-components/lib/assets/svg/HeartFillDark.svg';
import RewardsFill from 'yoda-core-components/lib/assets/svg/RewardsFill.svg';
import ScheduleApptFill from 'yoda-core-components/lib/assets/svg/ScheduleApptFill.svg';
import JcPennyBlack from 'yoda-core-components/lib/assets/svg/JcPenneyBlack.svg';
import Logout from 'yoda-core-components/lib/assets/svg/Logout.svg';
import ExternalLink from 'yoda-core-components/lib/assets/svg/ExternalLink.svg';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import Routing from 'yoda-account-components/lib/helpers/Routing/Routing';
import CreateMyList from '../../CreateMyList/CreateMyList';
import * as styles from '../CAMNav.css';

const cx = classNames.bind(styles);
const iconMappingList = {
    login: <Login />,
    'account-apollo': <AccountApollo />,
    'track-order': <TrackOrder />,
    address: <Address />,
    'address-new': <Address />,
    wallet: <Wallet />,
    'heart-fill': <HeartFill />,
    'rewards-fill': <RewardsFill />,
    'schedule-appt-fill': <ScheduleApptFill />,
    'jc-penney-black': <JcPennyBlack />,
    logout: <Logout />,
};
class NavItem extends PureComponent {
    static propTypes = {
        navData: PropTypes.shape({
            title: PropTypes.string,
            isRedirect: PropTypes.bool,
            url: PropTypes.string,
        }).isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
            query: PropTypes.shape({
                id: PropTypes.string,
            }),
        }).isRequired,
        enableSignInSlider: PropTypes.bool.isRequired,

        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        callBackProps: PropTypes.objectOf(PropTypes.func),
        navListCallBack: PropTypes.func,
        history: PropTypes.objectOf(PropTypes.func),
        isRewardsEnrolled: PropTypes.bool.isRequired,
        highlightActiveItem: PropTypes.bool,
        analyticsActions: PropTypes.objectOf(PropTypes.func).isRequired,
        rewardsSpend: PropTypes.number,
        isHideAccountMenuSlider: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        location: {
            pathname: '',
            query: {
                id: '',
            },
        },
        history: null,
        callBackProps: null,
        navListCallBack: () => {},
        isRewardsEnrolled: false,
        highlightActiveItem: true,
        rewardsSpend: 0,
        isHideAccountMenuSlider: false,
    };

    // this is better when its not recommended to hack for coverage
    /* istanbul ignore next */
    constructor(props) {
        super(props);

        const isRevealed = some(get(props, 'navData.children', []), this.isNavActive);

        this.state = {
            isRevealed,
            hasActiveChild: isRevealed,
        };

        this.callSignInSlider = this.callSignInSlider.bind(this);
        this.handleNavClick = this.handleNavClick.bind(this);
    }

    getLiClasses = (navData) => {
        const activeClass = 'active';
        if (this.isNavActive(navData)) return activeClass;
        return '';
    };

    getLocationString = ({ pathname = '' }) =>
        `${pathname.endsWith('/') ? pathname.slice(0, -1) : pathname}`;

    isItemHidden = (navData) => {
        const { isRewardsEnrolled } = this.props;
        const hideItem = get(navData, 'hideForRewardsNotEnrolled', false) && !isRewardsEnrolled;
        // MORE CONDITIONS GOES HERE FOR FUTURE
        return hideItem;
    };

    handleNavClick() {
        const { navListCallBack } = this.props;
        navListCallBack && navListCallBack(true);
    }

    isNavActive = (navData) => {
        const { location } = this.props;
        const currentPath = this.getLocationString(location);
        const query = makeQuery(location.search);
        const queryId = query && query.id;
        const type = get(navData, 'type');
        const isOtherUrl = get(navData, 'otherUrls') && includes(navData.otherUrls, currentPath);
        const isNavDataUrl = currentPath === navData.url;
        const isNavDataId = queryId && queryId === navData.id;
        if (isOtherUrl || isNavDataUrl || isNavDataId) {
            return true;
        }
        /* istanbul ignore next */
        if (type === 'dynamicList') {
            let extraData = [];
            try {
                if (!__SERVER__) {
                    extraData = JSON.parse(TokenProvider.get(get(navData, 'sourceKey', ''))) || [];
                }
            } catch (e) {
                console.log('Error in parsing JSON');
            }
            const activeListItem = extraData.find((item) => queryId === item.id);
            return !isEmpty(activeListItem);
        }
        return false;
    };

    // used to pass proper adobe analytics info when link is clicked
    analyticsForDefault(localTitle) {
        this.props.analyticsActions.triggerNavigationClick({
            linkName: localTitle,
            isReload: false,
        });
    }

    buildUrl = ({ url, scrollToId, id }) => {
        const parseUrl = scrollToId ? `${url}?scrollId=${id}` : url;
        return parseUrl;
    };

    callSignInSlider(linkData) {
        const {
            location: { pathname },
            callBackProps,
            history,
        } = this.props;
        const skipRedirection = true;
        let needStepUp = false;
        let isSignOut = false;
        const url = this.buildUrl(linkData);
        let stepUpUrl = url;
        const checkAction = (linkData.actionType || '').toLowerCase();
        /* istanbul ignore next */
        if (checkAction === 'signin') {
            needStepUp = true;
            stepUpUrl = '';
        } else if (checkAction === 'signout') {
            needStepUp = true;
            isSignOut = true;
            stepUpUrl = '';
        } else if (get(linkData, 'ensureRestrictedRoute')) {
            needStepUp = !Routing.ensureRestrictedRoute(pathname, false, skipRedirection);
        } else if (get(linkData, 'ensureRewardsRecognizedState')) {
            needStepUp = !Routing.ensureRewardsRecognizedState(pathname, false, skipRedirection);
        } else if (get(linkData, 'ensureAuthenticatedRoute')) {
            needStepUp = !Routing.ensureAuthenticatedRoute(pathname, false, skipRedirection);
        }

        if (needStepUp) {
            this.openSignInSlider(false, stepUpUrl, isSignOut);
            return;
        }

        if (linkData.isRedirect) {
            Routing.redirect(url, false);
        } else if (history && history.push) {
            history.push(url);
        } else {
            Routing.redirect(url, true);
        }

        /* istanbul ignore next */
        this.analyticsForDefault(`top:${linkData.title}`);
        // for calling callback passed
        callBackProps && callBackProps({}, 'camnav');
    }

    openSignInSlider = (isCreateAccount, nextUrl, isSignOut) => {
        // No need to mount signinslider incase of logout
        const { isHideAccountMenuSlider } = this.props;
        const customizeConfig = {
            forceLogin: true,
            skipOnAuthenticationSuccess: true,
            isHideAccountMenu: true,
            postAuthenticationUrl: nextUrl,
            isSliderCustomized: true,
        };
        /* istanbul ignore next */
        if (!isSignOut) {
            isHideAccountMenuSlider
                ? this.props.actions.customStepUp(customizeConfig)
                : this.props.actions.openSignInSlider(isCreateAccount, nextUrl, isSignOut);
        } else {
            // Perform logout and show tooltip
            this.props.actions.showLogoutToolTip();
        }
    };

    revealToggle = (e) => {
        e.preventDefault();
        this.setState({
            isRevealed: !this.state.isRevealed,
        });
    };

    prepareNavItemContent = (linkData) => {
        const { isRevealed } = this.state;
        const { isRewardsEnrolled, rewardsSpend } = this.props;
        const rewardsSpendText = get(linkData, 'rewardsSpendText', []);
        const showRewardsSpend =
            linkData.showRewardsSpend &&
            isRewardsEnrolled &&
            Number(rewardsSpend) !== 0 &&
            rewardsSpendText.length > 1;

        return (
            <div className={`${cx('item-content')} ${dt(['py-spacing-2', 'px-spacing-4'])}`}>
                <div className={cx('icon')}>
                    {linkData.iconName && (
                        <Icon iconType="svg" width="32px" height="32px" viewBox="0 0 40 40">
                            {iconMappingList[linkData.iconName]}
                        </Icon>
                    )}
                </div>
                <div className={cx('meta')}>
                    <div className={`${cx('title')} ${dt(['font-semibold'])}`}>
                        <div className={cx('text')}>{linkData.title}</div>
                        {linkData.isExternalLink && (
                            <div className={cx('icon-external')}>
                                <Icon iconType="svg" width="20px" height="20px" viewBox="0 0 40 40">
                                    <ExternalLink />
                                </Icon>
                            </div>
                        )}
                        {showRewardsSpend && (
                            <div className={cx('rewards-spend')}>
                                {linkData.rewardsSpendText[0]} <span>${rewardsSpend}</span>{' '}
                                {linkData.rewardsSpendText[1]}
                            </div>
                        )}
                    </div>
                    {linkData.subTitle && (
                        <div className={cx('sub-title')}>{linkData.subTitle}</div>
                    )}
                </div>
                {!isEmpty(linkData.children) && (
                    <div
                        className={cx(
                            'expand-action',
                            'btnRevealChild',
                            isRevealed ? 'revealed' : ''
                        )}
                    >
                        <Icon iconType="svg" width="20px" height="20px" viewBox="0 0 15 15">
                            <Plus />
                        </Icon>
                    </div>
                )}
            </div>
        );
    };

    prepareCreateMyList = () => {
        const { enableSignInSlider } = this.props;
        return (
            <li>
                <CreateMyList enableSignInSlider={enableSignInSlider} />
            </li>
        );
    };

    prepareCustomComponent(link) {
        const type = get(link, 'type');
        /* istanbul ignore next */
        if (type === 'dynamicList') {
            let extraData = [];
            try {
                if (!__SERVER__) {
                    extraData = JSON.parse(TokenProvider.get(get(link, 'sourceKey', ''))) || [];
                }
            } catch (e) {
                console.log('Error in parsing JSON');
            }
            return extraData.map((item) => {
                const linkData = {
                    url: `/mylist?id=${item.id}`,
                    title: item.name,
                    isRedirect: true,
                    id: item.id,
                };
                return this.prepareListItem(linkData, true);
            });
        }
        /* istanbul ignore else */
        if (type === 'CREATE_MY_LIST') {
            const creatMyList = this.prepareCreateMyList();
            return [creatMyList];
        }
        return [];
    }

    prepareLink = (linkData) => {
        const { enableSignInSlider } = this.props;
        const content = this.prepareNavItemContent(linkData);
        const url = this.buildUrl(linkData);

        // if linkdata has sublinks
        if (!isEmpty(linkData.children)) {
            const { isRevealed } = this.state;
            const links = linkData.children;
            const datas = flatten(
                links.map((navData) => {
                    if (navData.isCustom) {
                        return this.prepareCustomComponent(navData);
                    }
                    return this.prepareListItem(navData, true);
                })
            );
            return (
                <>
                    <Button
                        buttonType="Text"
                        className={cx('link-head')}
                        onClick={this.revealToggle}
                        automationId="left-nav-parent-ids"
                    >
                        {content}
                    </Button>
                    <ul className={cx('subLinks', isRevealed ? 'revealed' : '')}>{datas}</ul>
                </>
            );
        }

        let target = '';
        if (linkData.isExternalLink) {
            target = '_blank';
        }

        if (linkData.isExternalLink || (!enableSignInSlider && linkData.isRedirect)) {
            // when external link or other microsite link without signinSlider snabled
            return (
                <a href={url} className={cx('item-link')} target={target}>
                    {content}
                </a>
            );
        }
        if (enableSignInSlider) {
            // otherwise if signinsldier is enabled
            const automationId = linkData.automationId ? linkData.automationId : null;
            return (
                <Button
                    automationId={automationId}
                    buttonType="Text"
                    className={cx('item-link')}
                    onClick={() => this.callSignInSlider(linkData)}
                >
                    {content}
                </Button>
            );
        }

        // only remaining case is when we need to use Link component
        return (
            <Link to={url} className={cx('item-link')}>
                {content}
            </Link>
        );
    };

    prepareListItem = (linkData, isChildItem = false) => {
        const hideItem = this.isItemHidden(linkData);
        const { highlightActiveItem } = this.props;
        if (isEmpty(linkData) || hideItem) return null;

        let activeClass = '';
        /* istanbul ignore else */
        if (highlightActiveItem) activeClass = this.getLiClasses(linkData);

        let classList = ['list-item', activeClass];
        if (!isEmpty(linkData.children)) {
            const { isRevealed, hasActiveChild } = this.state;
            classList = classList.concat(['parent', isRevealed && 'has-revealed-list']);
        } else if (isChildItem) {
            classList = classList.concat('child');
        }

        // otherwise lets render simple link item
        const link = this.prepareLink(linkData);

        const liClass = cx(...classList);
        return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <li
                className={liClass}
                key={linkData.title}
                data-automation-id={isChildItem ? 'left-nav-child-ids' : 'left-nav-parent-ids'}
                onClick={this.handleNavClick}
            >
                {link}
            </li>
        );
    };

    render() {
        const { navData } = this.props;
        return this.prepareListItem(navData);
    }
}

export default NavItem;
